import { AlertTriangle } from "lucide-react";

import ScorecardGuideCard from "./Overview/ScorecardGuideCard";

import { Button } from "@/components/ui/button";

const getCreateButtonLabel = (isSaving: boolean): string => {
  if (isSaving) {
    return "Creating…";
  }
  return "Set up scorecard";
};

interface ScorecardCreateViewProps {
  isSaving: boolean;
  hasSimpleScore: boolean;
  conversionNotices?: string[];
  onCreate: () => void;
  onConvertLegacy?: () => void;
}

const ScorecardCreateView = ({
  isSaving,
  hasSimpleScore,
  conversionNotices = [],
  onCreate,
  onConvertLegacy,
}: ScorecardCreateViewProps) => (
  <div className="space-y-4">
    {hasSimpleScore && onConvertLegacy ? (
      <div className="rounded-lg border border-amber-200 bg-amber-50/60 px-4 py-3">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 inline-flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md border border-amber-200 bg-white/70 text-amber-700">
            <AlertTriangle className="h-3.5 w-3.5" aria-hidden="true" />
          </span>
          <div className="min-w-0 flex-1 space-y-2">
            <div>
              <p className="text-sm font-medium leading-5 text-amber-950">
                Legacy scoring is being deprecated
              </p>
              <p className="mt-1 text-sm leading-5 text-amber-900/80">
                Convert your existing score columns into scorecard evaluators to keep scoring this
                sheet.
              </p>
              {conversionNotices.length > 0 ? (
                <ul className="mt-2 list-disc space-y-1 pl-4 text-xs leading-5 text-amber-900/80">
                  {conversionNotices.map(notice => (
                    <li key={notice}>{notice}</li>
                  ))}
                </ul>
              ) : null}
            </div>
            <Button size="sm" onClick={onConvertLegacy} disabled={isSaving}>
              {isSaving ? "Converting…" : "Convert to scorecard"}
            </Button>
          </div>
        </div>
      </div>
    ) : null}

    {!hasSimpleScore ? (
      <ScorecardGuideCard
        title="Set up your scorecard"
        description="Create the scorecard, then add an evaluator that defines what a good row looks like."
        primaryActionLabel={getCreateButtonLabel(isSaving)}
        primaryActionDisabled={isSaving}
        onPrimaryAction={onCreate}
      />
    ) : null}
  </div>
);

export default ScorecardCreateView;
